import type {IssueEventItem} from '../../../../page-data/payloads/timeline'
import styles from './LabeledText.module.css'

export function LabeledText({item}: {item: IssueEventItem}) {
  const {eventType, label} = item.additionalInfo
  if (!label?.name) return <>{eventType === 'labeled' ? 'added a label' : 'removed a label'}</>
  return (
    <>
      <span>{eventType === 'labeled' ? 'added the ' : 'removed the '}</span>
      {label.color ? (
        <span data-testid="label-swatch" className={styles.labelSwatch} style={{backgroundColor: `#${label.color}`}} />
      ) : null}
      <strong>{label.name}</strong>
      <span> label</span>
    </>
  )
}
